import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getToken } from '../utils/helpers/token';

import type { TUserRole } from '../types/common';

import {
  AUTH_TAG,
  USERS_TAG,
  CONFIG_TAG,
  CONFIG_BASE_URL_TAG,
  CONFIG_EMAIL_TAG,
  CONFIG_SMS_TAG,
  CONFIG_TELEGRAM_TAG,
  CONFIG_TELEGRAM_CHAT_ROUTING_TAG,
  CONFIG_IMAGES_TAG,
  CURRENCIES_TAG,
  PAYMENTS_TAG,
  PAYMENTS_STATS_TAG,
  STATISTICS_TAG,
  WITHDRAWALS_TAG,
  SHOPS_TAG,
  PAYMENT_SYSTEMS_TAG,
  PAYMENT_METHODS_TAG,
  WITHDRAWAL_METHODS_TAG,
  REMOTE_PAYMENT_METHODS_TAG,
  WHITELIST_TAG,
  SHOP_COMMISSIONS_TAG,
  CONVERSION_PAIRS_TAG,
} from './tags';

const baseQuery = fetchBaseQuery({
  baseUrl: '/api/',
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery,
  tagTypes: [
    AUTH_TAG,
    USERS_TAG,
    CONFIG_TAG,
    CONFIG_BASE_URL_TAG,
    CONFIG_EMAIL_TAG,
    CONFIG_SMS_TAG,
    CONFIG_TELEGRAM_TAG,
    CONFIG_TELEGRAM_CHAT_ROUTING_TAG,
    CONFIG_IMAGES_TAG,
    CURRENCIES_TAG,
    PAYMENTS_TAG,
    PAYMENTS_STATS_TAG,
    STATISTICS_TAG,
    WITHDRAWALS_TAG,
    SHOPS_TAG,
    PAYMENT_SYSTEMS_TAG,
    PAYMENT_METHODS_TAG,
    WITHDRAWAL_METHODS_TAG,
    REMOTE_PAYMENT_METHODS_TAG,
    WHITELIST_TAG,
    SHOP_COMMISSIONS_TAG,
    CONVERSION_PAIRS_TAG,
  ],
  endpoints: (build) => ({
    getCurrencies: build.query<string[], void>({
      query: () => '/currencies',
      providesTags: [CURRENCIES_TAG],
    }),

    getUserRoles: build.query<TUserRole[], void>({
      query: () => '/admin/users/roles',
      providesTags: [AUTH_TAG],
    }),

  }),
});

export const {
  useGetCurrenciesQuery,
  useGetUserRolesQuery,
} = baseApi;
